if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.zoomLevel = 1;
        this.thumbnailButtons = this.querySelectorAll('[data-product-media-thumbnail]');
        this.zoomInButton = this.querySelector('[data-product-media-zoom-in]');
        this.zoomOutButton = this.querySelector('[data-product-media-zoom-out]');

        this.thumbnailButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.showActiveMedia(button.dataset.mediaId);
          });
          button.addEventListener('pointerup', (event) => event.stopPropagation());
        });

        this.zoomInButton?.addEventListener('click', (event) => {
          event.stopPropagation();
          this.setZoom(this.zoomLevel + 0.25);
        });
        this.zoomOutButton?.addEventListener('click', (event) => {
          event.stopPropagation();
          this.setZoom(this.zoomLevel - 0.25);
        });

        this.querySelector('.product-media-modal__controls')?.addEventListener('pointerup', (event) => event.stopPropagation());
        this.querySelector('.product-media-modal__content')?.addEventListener('pointerup', (event) => event.stopPropagation());
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia(opener.getAttribute('data-media-id'));
      }

      showActiveMedia(mediaId) {
        const mediaItems = this.querySelectorAll('.product-media-modal__content [data-media-id]');
        const activeMedia = this.querySelector(`.product-media-modal__content [data-media-id="${mediaId}"]`);

        if (!activeMedia) return;

        mediaItems.forEach((element) => {
          element.classList.remove('active');
        });
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        container.scrollTop = 0;
        container.scrollLeft = 0;
        this.thumbnailButtons.forEach((button) => {
          const isActive = button.dataset.mediaId === mediaId;
          button.classList.toggle('is-active', isActive);
          button.toggleAttribute('aria-current', isActive);
        });
        this.setZoom(1);

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      setZoom(level) {
        this.zoomLevel = Math.min(Math.max(level, 1), 2);
        const activeMedia = this.querySelector('.product-media-modal__content [data-media-id].active');
        if (activeMedia) activeMedia.style.setProperty('--product-media-zoom', this.zoomLevel);
        if (this.zoomInButton) this.zoomInButton.disabled = this.zoomLevel >= 2;
        if (this.zoomOutButton) this.zoomOutButton.disabled = this.zoomLevel <= 1;
      }
    }
  );
}
